import { useEffect } from "react";
import { FAQ_ITEMS, SERVICE_AREAS, PRICING_TIERS } from "@/lib/constants";

// Injects FAQ + Service + LocalBusiness JSON-LD into <head>
// Complements the static LocalBusiness schema in index.html
export default function SEOSchema() {
  useEffect(() => {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_ITEMS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };

    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Junk Removal",
      provider: {
        "@type": "LocalBusiness",
        name: "Come Pick Up My Trash",
        telephone: "+1-216-306-2330",
        email: "bookings@comepickupmytrash.com",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Cleveland",
          addressRegion: "OH",
          addressCountry: "US",
        },
      },
      areaServed: SERVICE_AREAS.map((a) => ({
        "@type": "City",
        name: a,
        containedInPlace: { "@type": "AdministrativeArea", name: "Cuyahoga County, OH" },
      })),
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Junk Removal Pricing",
        itemListElement: PRICING_TIERS.map((t) => ({
          "@type": "Offer",
          name: `${t.name} — ${t.itemCount}${t.plus ? "+" : ""} item${t.itemCount > 1 ? "s" : ""}`,
          price: t.price,
          priceCurrency: "USD",
          description: t.tagline,
        })),
      },
    };

    const nodes = [
      makeNode("seo-faq-schema", faqSchema),
      makeNode("seo-service-schema", serviceSchema),
    ];
    nodes.forEach((n) => document.head.appendChild(n));
    return () => {
      nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
    };
  }, []);

  return null;
}

function makeNode(id, data) {
  // Remove any previously-injected copy to avoid duplicates on navigation
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.id = id;
  s.text = JSON.stringify(data);
  return s;
}
